var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPrinter = function SvgPrinter(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1199 25.32C43.0478 25.32 43.7999 24.5678 43.7999 23.64C43.7999 22.7121 43.0478 21.96 42.1199 21.96C41.1921 21.96 40.4399 22.7121 40.4399 23.64C40.4399 24.5678 41.1921 25.32 42.1199 25.32Z",
    fill: "#4A90FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5999 18.6001V7.84009C39.5999 7.2878 39.1522 6.84009 38.5999 6.84009H15.3999C14.8476 6.84009 14.3999 7.2878 14.3999 7.84009V18.6001",
    stroke: "#4A90FF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5999 30.3601C39.1522 30.3601 39.5999 30.8078 39.5999 31.3601V46.1601C39.5999 46.7124 39.1522 47.1601 38.5999 47.1601H15.3999C14.8476 47.1601 14.3999 46.7124 14.3999 46.1601V31.3601C14.3999 30.8078 14.8476 30.3601 15.3999 30.3601H38.5999Z",
    stroke: "#4A90FF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4001 39.6001H8.52009C7.59273 39.6001 6.84009 38.8475 6.84009 37.9201V20.2801C6.84009 19.3527 7.59273 18.6001 8.52009 18.6001H45.4801C46.4075 18.6001 47.1601 19.3527 47.1601 20.2801V37.9201C47.1601 38.8475 46.4075 39.6001 45.4801 39.6001H39.6001",
    stroke: "#4A90FF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4001 35.3999H18.6001",
    stroke: "#4A90FF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0401 38.76H18.6001",
    stroke: "#4A90FF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4001 42.1201H18.6001",
    stroke: "#4A90FF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrinter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/printer.168cc4a9.svg";
export { ForwardRef as ReactComponent };